<template>
    <div class="addBank">
        <!--添加/编辑签章弹出框-->
        <el-dialog
            :title="title + '银行卡信息'"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            @close="resetForm"
            width="800px"
        >
            <div class="dialogBoxClass">
                <el-form
                    :model="form"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="130px"
                    class="demo-ruleForm"
                >
                    <el-form-item label="银行卡号" prop="bankCardNo">
                        <el-input
                            v-model="form.bankCardNo"
                            placeholder="请输入银行账户号码"
                            @change="discriminate"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="开户行" prop="bankCode">
                        <el-select v-model="form.bankCode"
                                   @change="handleBankChange"
                                   filterable placeholder="请选择开户行">
                            <el-option
                                v-for="item in bankList"
                                :key="item.code"
                                :label="item.value"
                                :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="银行卡类型" prop="bankCardType">
                        <el-select
                            v-model="form.bankCardType"
                            clearable
                            placeholder="请选择银行账户类型"
                        >
                            <el-option label="借记卡" value="DEBIT_CARD"></el-option>
                            <el-option label="对公卡" value="PUBLIC_CARD">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="submitForm">确认</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    searchBankCarBinInfo,
    addSettledCard
} from "../../utils/interface";
import bankList from '../../utils/bankData';

export default {
    name: "addBank",
    data() {
        return {
            dialogVisible: false,
            title: "",
            form: {
                bankCardNo: "",
                bankCode: "",
                bankCardType: "",
                bankName: "",
            },
            // 银行
            bankList:bankList,
            rules: {
                bankCardNo: [
                    {required: true, message: "请选择输入银行卡号", trigger: "blur"},
                ],
                bankCode: [
                    {required: true, message: "银行编码不能为空", trigger: "blur"},
                ],
                bankCardType: [
                    {required: true, message: "银行卡类型不能为空", trigger: "blur"},
                ],
                bankName: [
                    {required: true, message: "银行名称不能为空", trigger: "blur"},
                ],
            },
        };
    },
    inject: ['searchSettleCard'],
    methods: {
        init(type) {
            type == "add" ? this.title = "添加" : this.title = "修改";
            this.dialogVisible = true;
        },
        handleBankChange(val){
            let checkLabel = this.bankList.find( item => item.code ===val).value;
            this.form.bankName = checkLabel;
        },
        resetForm(){
            this.$refs.ruleForm.resetFields();
        },
        discriminate(card) {
            searchBankCarBinInfo(card).then(resp => {
                if (resp.success) {
                    this.form.bankCode = resp.data.bankCode;
                    this.form.bankName = resp.data.bankName;
                    if ("DEBIT_CARD" === resp.data.bankCardType) {
                        this.form.bankCardType = "DEBIT_CARD";
                    } else {
                        this.form.bankCardType = "PUBLIC_CARD";
                    }
                }else{
                    this.form.bankCode= "";
                    this.form.bankCardType= "";
                    this.form.bankName="";
                }
            });
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    addSettledCard(this.form).then(resp=>{
                        if (resp.success) {
                            this.resetForm();
                            this.$message.success("保存成功");
                            this.dialogVisible = false;
                            this.searchSettleCard();
                        } else {
                            this.$message.error(resp.message);
                        }
                    });
                }else{
                    this.$message.error("请填写完整信息");
                }
            });
        },
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/balance/addBank.vue